var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgVoteLogo = function SvgVoteLogo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 20"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#voteLogo_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#voteLogo_svg__b)",
    fillRule: "evenodd",
    d: "M14.737 16.34q4.033-3.982 8.022-8.006c1.351-1.364 1.346-3.343.034-4.73a42 42 0 0 0-1.9-1.907C20.014.879 18.96.493 17.786.85c-.596.183-1.217.5-1.658.93-1.679 1.631-3.327 3.295-4.974 4.958L9.485 8.42l-.11.111q-.12.124-.245.242c-.39.368-.787.346-1.159-.018-.386-.379-.365-.787.003-1.156.64-.643 1.288-1.277 1.971-1.946l.838-.82-.975-.96c-.751-.739-1.47-1.448-2.197-2.15C6.245.403 4.273.387 2.881 1.698A48 48 0 0 0 .978 3.603c-1.308 1.376-1.31 3.38.03 4.73Q5 12.356 9.034 16.34H0v2.943h23.774V16.34z",
    clipRule: "evenodd"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "voteLogo_svg__b",
    x1: 0,
    x2: 21.398,
    y1: 9.072,
    y2: 9.072,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2F54EB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9747FF"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "voteLogo_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 .717h24v18.566H0z"
  })))));
};
export default SvgVoteLogo;